import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { PreloaderService } from '@core';
import { DataService } from '@core/bootstrap/data.service';
import { LocalStorage } from '@core/bootstrap/localstorage.service';
import { AlertService } from '@shared/components/alert/alert.service';
import { ConfirmationDialog } from '@shared/components/confirmation-dialog/confirmation-dialog.component';
import { LanguagePipe } from '@shared/pipes/language.pipe';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-payment-list',
  templateUrl: './payment-list.component.html',
  styleUrls: ['./payment-list.component.scss']
})
export class PaymentListComponent implements OnInit ,OnDestroy {
  branches: any = [];
  payData: any = [];
  branch_id: any = (localStorage.getItem('selectedBranch') != null) ? localStorage.getItem('selectedBranch') : '0';
  lodingdatas = this.lang.transform('lang_loading');
  finances: any = [];

  paypage_no:any    = localStorage.getItem('AC_PY_P') || 1;
  paypage_size:any  = localStorage.getItem('AC_PY_S') || '10';
  finance_id: any   = localStorage.getItem('AC_PY_S_F') || null;
  searchKey:any     = localStorage.getItem('AC_PY_S_K') || "";

  accAction:string  = "LIST";


  constructor(public ds:DataService,public datePipe: DatePipe,public router : Router, public ls:LocalStorage ,public lang:LanguagePipe, public spinner:PreloaderService, public fb:FormBuilder, public alert:AlertService, public dialog:MatDialog, public modalService: BsModalService,) { 
    this.spinner.show();
    this.load_branches();
  }
  ngOnInit(): void {
    if (this.branch_id && this.branch_id != '0') {
      this.load_financial_years();
    }
  }
  private subscriptions = new Subscription();
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
  public selectBrach(branch) {
    if (branch && branch !='0' ) {
      localStorage.setItem('selectedBranch', branch);
      this.branch_id = branch;
      this.load_financial_years();
    } else {
      this.spinner.hide();
    }
  }
  public load_branches() {
    this.branches = [];
    this.subscriptions.add(
        this.ds.getActionByUrl([], 'ab/accounts_view').subscribe(res => {
          this.spinner.hide();
          if (res.status) {
            this.branches = res.records;
          }
        }, error => {
          this.spinner.hide();
        })      
      )

  }
  public load_financial_years() {
    this.finances = [];
    this.finance_id = null;
    this.subscriptions.add(
        this.ds.getActionByUrl([], 'financial/' + this.branch_id).subscribe(res => {
          this.spinner.hide();
          if (res.status) {
            this.finances = res.records;
            this.finances.forEach((v, k) => {
              if (v.finance_status == "1") {
                this.finance_id = v.finance_id;
              }
            });
          }
          this.load_payments();
        }, error => {
          this.spinner.hide();
        })      
      )

  }
  public loadPagePay(page) {
    this.spinner.show();
    this.paypage_no = page;
    this.paypage_size = this.paypage_size;
    this.load_payments();
  }
  public loadPayPagesize(size) {
    this.spinner.show();
    this.paypage_no = 1;
    this.paypage_size = size;
    this.load_payments();
  }
  public search_payments() {
    this.paypage_no = 1;
    this.paypage_size = '10';
    this.load_payments();
  }
  public load_payments() {
    //Accounts Payments
		localStorage.setItem('AC_PY_S_K', this.searchKey);
		localStorage.setItem('AC_PY_S_F', this.finance_id);
		localStorage.setItem('AC_PY_P',  this.paypage_no);
		localStorage.setItem('AC_PY_S',  this.paypage_size);
    let formdata = new FormData();
    this.branch_id = (this.branch_id) ? this.branch_id : 0;
    formdata.append('search_key', this.searchKey);
    formdata.append('finance_id', (this.finance_id) ? this.finance_id : '0');
    this.subscriptions.add(
        this.ds.postActionByUrl(formdata, 'listpayments/' + this.branch_id + '/' + this.paypage_no + '/' + this.paypage_size).subscribe(res => {
          this.spinner.hide();
          if (res.status) {
            this.payData = res;
          } else {
            this.payData = [];
            this.lodingdatas = res.error;
          }
        }, error => {
          this.spinner.hide();
          this.payData = [];
          this.lodingdatas = (error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error');
        })      
      )

  }
  public remove_payment(data) {
    const dialogRef = this.dialog.open(ConfirmationDialog,{
      disableClose: true,
      width:'400px',
      data:{
        title: this.lang.transform('lang_confirmation'),
        message: this.lang.transform('lang_are_you_sure'),          
      }
    });
    this.subscriptions.add(
        dialogRef.afterClosed().subscribe((confirmed: boolean) => {
          if (confirmed) {
            this.spinner.show();
            this.subscriptions.add(
              this.ds.deleteActionByUrl([], 'deletepayment/' + this.branch_id + '/' + data.transaction_id + '/' + data.payment_receipt_id).subscribe(
                      (data) => {
                        this.spinner.hide();
                        if (data.status) {
                          this.load_payments();
                          this.ds.dialogf('',data.msg);
                        } else {
                          this.ds.dialogf('',data.error);
                        }
                      },
                      (error) => {
                        this.spinner.hide();
                        this.ds.dialogf('',(error && error.error && error.error.error) ? error.error.error : this.lang.transform('lang_internal_server_error'));
                      }
                    )
              )
            ;
          }
        })      
      )
;
  }
}
